/**
 * Central pt-BR labels for workflow node types.
 * Single source for: NodeConfigPanel subtitle, execution history,
 * workflows listing chips. Canvas default labels (uppercase) derive from it.
 */
export const NODE_TYPE_LABELS: Record<string, string> = {
  trigger_event: 'Gatilho: Evento',
  trigger_schedule: 'Gatilho: Agendamento',
  trigger_webhook: 'Gatilho: Webhook',
  trigger_manual: 'Gatilho: Manual',
  trigger_date_field: 'Gatilho: Campo de Data',
  trigger_inactivity: 'Gatilho: Inatividade',
  trigger_instagram_comment: 'Gatilho: Comentário Instagram',
  trigger_instagram_mention: 'Gatilho: Menção Instagram',
  action_send_message: 'Ação: Enviar Mensagem',
  action_send_email: 'Ação: Enviar E-mail',
  action_send_template: 'Ação: Enviar Template',
  action_send_media: 'Ação: Enviar Mídia',
  action_http_request: 'Ação: Requisição HTTP',
  action_query_database: 'Ação: Consultar Base',
  action_create_lead: 'Ação: Criar Lead',
  action_update_lead: 'Ação: Atualizar Lead',
  action_update_contact: 'Ação: Atualizar Contato',
  action_add_tag: 'Ação: Adicionar Tag',
  action_remove_tag: 'Ação: Remover Tag',
  action_assign: 'Ação: Distribuir',
  action_create_conversation: 'Ação: Criar Conversa',
  action_transfer_conversation: 'Ação: Transferir Conversa',
  action_satisfaction_survey: 'Ação: CSAT — Satisfação do Cliente',
  action_ask_question: 'Ação: Pergunta',
  action_ask_form: 'Ação: Perguntar formulário',
  action_next_number: 'Ação: Número sequencial',
  action_save_form_response: 'Ação: Salvar formulário',
  action_create_ticket: 'Ação: Criar Ticket',
  action_set_variable: 'Ação: Definir Variável',
  action_internal_notification: 'Ação: Notificação Interna',
  action_find_leads: 'Ação: Buscar Leads',
  action_create_database_document: 'Ação: Criar Documento em Base',
  action_create_checklist: 'Ação: Criar Checklist',
  action_find_unit: 'Ação: Buscar unidade',
  action_find_user: 'Ação: Buscar usuário',
  action_find_contact: 'Ação: Buscar ou criar contato',
  action_url_to_pdf: 'Ação: Gerar PDF de uma página',
  action_nfe_pdf: 'Ação: Gerar PDF da nota fiscal',
  action_voice_clone: 'Ação: Clonar Voz (efêmero)',
  action_voice_tts: 'Ação: Falar com Voz Clonada',
  action_voice_clone_delete: 'Ação: Deletar Voz Clonada',
  action_mirror_media: 'Ação: Espelhar Mídia no S3',
  control_if: 'Controle: Condição',
  control_switch: 'Controle: Switch',
  control_wait_for: 'Controle: Aguardar',
  control_loop: 'Controle: Loop',
  control_split: 'Controle: Teste A/B',
  control_retry_scope: 'Controle: Tentar Novamente (escopo)',
  ai_agent: 'IA: Agente',
  ai_agent_inline: 'IA: Agente Inline',
  skill_input: 'Skill: Entrada',
  skill_output: 'Skill: Saída',
};

/** Short labels for trigger type chips (listing/history) */
export const TRIGGER_TYPE_SHORT_LABELS: Record<string, string> = {
  trigger_event: 'Evento',
  trigger_schedule: 'Agendamento',
  trigger_webhook: 'Webhook',
  trigger_manual: 'Manual',
  trigger_date_field: 'Campo de Data',
  trigger_inactivity: 'Inatividade',
  trigger_instagram_comment: 'Comentário Instagram',
  trigger_instagram_mention: 'Menção Instagram',
};

export function getNodeTypeLabel(nodeType: string): string {
  return NODE_TYPE_LABELS[nodeType] ?? nodeType.replace(/_/g, ' ');
}

export function getTriggerTypeLabel(triggerType: string): string {
  return TRIGGER_TYPE_SHORT_LABELS[triggerType] ?? triggerType.replace('trigger_', '').replace(/_/g, ' ');
}
